import { loadRuntimeConfig } from './config/runtime';

void loadRuntimeConfig()
  .then(() => import('./bootstrap'))
  .catch(() => {
    const root = document.getElementById('root');
    if (root) root.textContent = 'Unable to load the application. Please try again later.';
  });
